// extracted by mini-css-extract-plugin
export var reverse = "about-box-module--reverse--1c70b";
export var teamInfo = "about-box-module--teamInfo--afc94";
export var teamMember = "about-box-module--teamMember--362c4";
export var teamMemberImg = "about-box-module--teamMemberImg--92d8c";